<template>
  <div class="commmunity-wrap">
    <!-- 列表标题 -->
    <div class="commmunity-title">微社区</div>
    <div class="btn">
      <Button class="bkcc-btn" @click="goCommittee">物委会信息</Button>
      <Button class="bkcc-btn" @click="downloadRecordCard">下载登记卡</Button>
      <Button class="bkcc-btn" @click="showModal.value = true">新建微社区</Button>
    </div>
    <!-- 列表 -->
    <section class="list-wrap">
      <bk-orgcard
        v-for="item in list"
        :key="item.id"
        :party="item"
        @on-click="toDetail(item)"
        @on-delete="onDelete(item)"
        @on-detail-click="onBuildingDetail(item)"
      ></bk-orgcard>
    </section>
    <!-- 分页 -->
    <Page
      class="page-wrap"
      show-total
      :total="total"
      :page-size="pageSize"
      @on-change="onPageChange"
    ></Page>

    <!-- modal -->
    <add-org-modal :showModal="showModal" @on-success="onAddSuccess"></add-org-modal>
  </div>
</template>

<script>
import bkOrgcard from "./components/org-card";
import addOrgModal from "./components/addorg-modal";

// 默认行政区域id索引
const DEFAULTFILTERIDINDEX = 0;
export default {
  name: "",
  components: { bkOrgcard, addOrgModal },
  props: {},
  data() {
    return {
      list: [],

      pageNum: 1,
      pageSize: 6,
      total: 0,

      filterList: [], // 右侧栏的过滤选项

      showModal: {
        value: false
      } // 显示弹窗
    };
  },
  watch: {},
  computed: {
    // 当前选择行政区域的id
    orgId: {
      get() {
        return this.$store.state.miniCommunityChangeId;
      },
      // 存储选择的id到全局变量 保持同步
      set(val) {
        this.$store.commit("updateMiniCommunityChangeId", val);
      }
    }
  },
  methods: {
    // 打开微社区详情
    toDetail(cur) {
      this.$router.push({
        name: "communityDetail",
        query: { zoneId: cur.id }
      });
    },
    // 楼宇详情
    onBuildingDetail(item) {
      console.log("building", item);
      this.$router.push({
        name: "communityBuilding",
        query: { id: item.id }
      });
    },
    // 批量下载登记卡
    downloadRecordCard() {
      let comeIdList = this.list.map(item => item.id).join(",");
      let url = `${this.urlobj.walkRecordDownload}?token=${this.$store.state.access_token}&comeType=1&comeIdList=${comeIdList}`;
      window.open(url);
    },
    goCommittee() {
        this.$router.push({
        name: "committee",
        params: { zoneId: null }
      });
    },
    // 删除微社区
    onDelete(cur) {
      this.$Modal.confirm({
        title: "提示",
        loading: true,
        // prettier-ignore
        content: `确认要删除<b style="color:#f43f3e">${cur.zoneName || ''}及相关数据</b>吗？`,
        onOk: () => {
          let url = this.urlobj.delWzb(cur.id);
          this.$delete(url).then(res => {
            if (!res.isSucceed) return this.$Message.error(res.message);
            this.$Message.success("删除成功");
            this.$Modal.remove();

            // 刷新页面数据
            this.getFilterList();
            this.getList();
          });
        }
      });
    },
    // 页面分页
    onPageChange(e) {
      this.pageNum = e;
      this.getList();
    },
    // 微社区添加成功
    onAddSuccess() {
      this.getFilterList();
      this.getList();
    },
    // 行政区域选择变化
    areaChange({ params }) {
      // prettier-ignore
      let cur = this.filterList[params.filterListIndex].data.dataList[params.selectedIndex];
      this.orgId = cur.id;

      // 刷新页面数据
      this.getList();
    },
    /* 过滤器重置 */
    _reset() {
      // 右侧暂时只有一个组件 多个可重新初始化组件以重置
      this.filterList[0].data.selectedIndex = 0;
    },
    /* 获取右侧过滤器列表 */
    getFilterList() {
      let url = this.urlobj.zoneLabel;
      this.$get(url)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          // 显示文本组件
          this.$store.commit("updateLabelList", [
            {
              name: "filter_label",
              data: {
                label: "小区(微社区)总数",
                value: res.newPrimaryKeys.zoneCount
              }
            }
          ]);
          // 过滤器组件
          let singleDivisionDataList = res.rows.map(item => {
            return {
              id: item.communityId,
              label: item.communityName,
              number: item.zoneCount
            };
          });
          // 获取行政区域选中索引
          let index = singleDivisionDataList.reduce((pre, cur, index) => {
            if (cur.id == this.orgId) pre = index;
            return pre;
          }, DEFAULTFILTERIDINDEX);

          this.filterList = [
            {
              name: "singleDivision",
              data: {
                title: "行政区域",
                edit: false,
                selectedIndex: index,
                dataList: singleDivisionDataList
              },
              event: e => {
                this[e.fn](e);
              }
            }
          ];
          
          this.$store.commit("updateFilterList", this.filterList);
        })
        .catch(e => {
          this.$Message.error("分类获取失败");
        });
    },
    // 获取列表
    getList() {
      let url = this.urlobj.zoneList;
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        communityId: this.orgId
      };
      this.$showLoading();
      this.$post(url, data)
        .then(res => {
          if (!res.isSucceed) return this.$Message.error(res.message);

          this.list = res.rows.map(item => ({
            id: item.id,
            zoneName: item.zoneName,
            clerkName: item.leader.length ? item.leader[0].realName : "暂无",
            activityCount: item.activityCount.activityCount,
            reportEventCount: item.eventCount.eventCount,
            voteCount: item.voteCount.voteCount,
            userCount: item.info.totalNumber
          }));

          this.total = res.total;
        })
        .finally(this.$hideLoading);
    }
  },
  created() {
    this.getFilterList();
    // 过滤器重置
    this.reset = this._.debounce(this._reset, 500);
  },
  mounted() {
    // 微支部为社区列表
    this.getList();
  }
};
</script>
<style lang="less" scoped>
@titleColor: #666;
@titleFontSize: 24px;
@titleFontSizeFix: 22px;
@bodyPadding: 20px;

.commmunity-wrap {
  box-sizing: border-box;
  padding: 30px 20px;

  height: calc(100vh - 60px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
.commmunity-title {
  font-size: @titleFontSize;
  color: @titleColor;
  text-align: center;
}
.btn {
  position: absolute;
  top: 30px;
  right: 20px;
}
.list-wrap {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(510px, 1fr));
  grid-gap: 30px;
  align-items: start;

  min-height: 630px;
  margin-top: 30px;
}
.page-wrap {
  margin-top: 30px;
  text-align: center;
}
</style>
